import styled from 'styled-components';

export const StyledFlag = styled.span`
  font-size: 1.125rem;
  line-height: 1;
`;
